<template>
<div class="sezione"  style="padding:0 8px;" >


<div class="yo-fixed-top" style="top:132px;z-index:999;">
<div class="row el-container" style="background:#fff;padding:16px 20px;">
   <div class="col s12">
      <el-breadcrumb separator-class="el-icon-arrow-right" style="line-height: 36px;">
         <el-breadcrumb-item><span class="yo-text-bold yo-text-m">Esame della retina per centro</span></el-breadcrumb-item>
         <el-breadcrumb-item><span class=" yo-text-m">Neonati con EG {{gaweakDown}}-{{gaweakUp}} sett.</span></el-breadcrumb-item>
         <el-breadcrumb-item><span class="yo-text-m">Anno 2021</span></el-breadcrumb-item> 
      </el-breadcrumb>
   </div>
</div>
</div>
<div style="margin:40px 0;">
   <div  style="position: relative;">

      <div style="display: flex;">
      <img src="../assets/funnel-eyex-2021.svg" alt="FUNNEL PLOT" style="width:100%;justify-self: flex-end;"/>
      </div>

      <template v-for="(itm, index) in dati"  >
         <div v-if="$centro.profile.row.id==itm.centro" :key="index+'_'+itm.centro" :style="'left: '+xpos(itm.x)+'px;bottom:'+ypos(itm.y)+'px;background: red;position: absolute;width: '+pointw+'px;height: '+pointw+'px;border-radius: 1'+pointw/3+'px;'"></div>
      </template>  

   </div>
   <div class="yo-align-center yo-text-bold yo-text-m">Numero di neonati</div>
</div>



</div>
</template>

<script>

export default {
components: {
   
},
data() {
   return {
      loading:{}
      ,pointw: 24

      ,boxw:1380
      ,boxh:728

      ,ploth:640.7
      ,plotw:1258.2
      ,funnelsx: 91.4
      ,funnelbottom: 728-667.9

      ,maxw: 97
      ,maxh: 1
      ,minh: 0.4

      ,dati:[

      {centro:10016,x:1,y:1},
{centro:10017,x:23,y:0.85},
{centro:10018,x:6,y:0.6},
{centro:10019,x:38,y:0.93},
{centro:10021,x:7,y:0.78},
{centro:10024,x:45,y:0.62},
{centro:10025,x:24,y:0.69},
{centro:10028,x:18,y:0.86},
{centro:10029,x:72,y:0.75},
{centro:10030,x:34,y:0.89},
{centro:10031,x:24,y:0.71},
{centro:10034,x:33,y:0.85},
{centro:10035,x:48,y:0.77},
{centro:10036,x:27,y:0.69},
{centro:10038,x:1,y:1},
{centro:10039,x:29,y:0.88},
{centro:10040,x:1,y:1},
{centro:10042,x:8,y:1},
{centro:10043,x:26,y:0.74},
{centro:10044,x:41,y:0.82},
{centro:10045,x:42,y:0.88},
{centro:10046,x:68,y:0.84},
{centro:10047,x:10,y:1},
{centro:10049,x:36,y:0.9},
{centro:10050,x:11,y:0.92},
{centro:10051,x:31,y:0.82},
{centro:10052,x:4,y:0.8},
{centro:10053,x:2,y:1},
{centro:10054,x:39,y:0.74},
{centro:10056,x:14,y:0.78},
{centro:10057,x:23,y:0.77},
{centro:10058,x:12,y:0.86},
{centro:10060,x:9,y:0.75},
{centro:10061,x:26,y:0.87},
{centro:10062,x:16,y:0.76},
{centro:10063,x:17,y:0.94},
{centro:10064,x:1,y:0.5},
{centro:10065,x:5,y:0.63},
{centro:10067,x:10,y:0.91},
{centro:10068,x:19,y:0.83},
{centro:10069,x:21,y:0.95},
{centro:10070,x:61,y:0.69},
{centro:10072,x:6,y:1},
{centro:10073,x:13,y:0.54},
{centro:10075,x:39,y:0.89},
{centro:10077,x:7,y:0.88},
{centro:10078,x:18,y:0.95},
{centro:10079,x:18,y:0.78},
{centro:10081,x:9,y:0.82},
{centro:10082,x:13,y:0.72},
{centro:10083,x:46,y:0.85},
{centro:10085,x:11,y:0.79},
{centro:10087,x:5,y:0.63},
{centro:10088,x:0,y:0},
{centro:10089,x:38,y:0.84},
{centro:10091,x:17,y:0.68},
{centro:10094,x:48,y:0.86},
{centro:10100,x:11,y:0.92},
{centro:10102,x:2,y:1},
{centro:10103,x:22,y:0.88},
{centro:10104,x:16,y:0.52},
{centro:10107,x:49,y:0.68},
{centro:10109,x:30,y:0.91},
{centro:10110,x:22,y:0.85},
{centro:10111,x:16,y:0.84},
{centro:10114,x:64,y:0.67},
{centro:10116,x:8,y:0.47},
{centro:10118,x:35,y:0.92},
{centro:10123,x:15,y:0.75},
{centro:10124,x:4,y:0.8},
{centro:10126,x:0,y:0},
{centro:10127,x:2,y:0.67},
{centro:10128,x:8,y:1},
{centro:10129,x:52,y:0.79},
{centro:10130,x:3,y:1},
{centro:10133,x:15,y:0.71},
{centro:10134,x:32,y:0.94},
{centro:10137,x:26,y:0.93},
{centro:10139,x:0,y:0},
{centro:10140,x:11,y:0.92},
{centro:10141,x:17,y:0.94},
{centro:10145,x:23,y:0.68},
{centro:10146,x:24,y:0.75},
{centro:10149,x:11,y:0.5},
{centro:10150,x:6,y:1},
{centro:10151,x:8,y:0.8},
{centro:10152,x:5,y:0.83},
{centro:10153,x:21,y:0.84},
{centro:10166,x:4,y:1},
{centro:10169,x:5,y:0.83},





      ]



   }
},
created () {
},
methods: {
   xpos(x){
      return this.plotw/this.maxw*x + this.funnelsx - this. pointw/2
   },
   ypos(y){
      return this.ploth/(this.maxh-this.minh)*(y-this.minh) + this.funnelbottom - this. pointw/2
   }
}, 
computed:{
}
}
</script>


<style >

</style>
